const CHUNK_RELOAD_KEY = 'bizbee-qsc:chunk-reload-at'
const CHUNK_RELOAD_PARAM = '__qsc_reload'
const CHUNK_RELOAD_COOLDOWN_MS = 30_000

const CHUNK_ERROR_PATTERNS = [
  'failed to fetch dynamically imported module',
  'error loading dynamically imported module',
  'importing a module script failed',
  'chunkloaderror',
  'loading chunk',
  'css_chunk_load_failed',
  'unable to preload css',
  'vite:preloaderror',
]

function stringifyError(error: unknown): string {
  if (!error) return ''
  if (typeof error === 'string') return error
  if (error instanceof Error) return `${error.name} ${error.message}`
  if (error instanceof Event) {
    const target = error.target
    const targetUrl =
      target instanceof HTMLScriptElement
        ? target.src
        : target instanceof HTMLLinkElement
          ? target.href
          : ''
    return `${error.type} ${targetUrl}`
  }
  if (typeof error === 'object') {
    const maybeError = error as { message?: unknown; reason?: unknown; type?: unknown }
    return [maybeError.type, maybeError.message, stringifyError(maybeError.reason)]
      .filter(Boolean)
      .join(' ')
  }
  return String(error)
}

export function isChunkLoadError(error: unknown) {
  const message = stringifyError(error).toLowerCase()
  return CHUNK_ERROR_PATTERNS.some((pattern) => message.includes(pattern))
}

export function clearChunkReloadParam() {
  const url = new URL(window.location.href)
  if (!url.searchParams.has(CHUNK_RELOAD_PARAM)) return
  url.searchParams.delete(CHUNK_RELOAD_PARAM)
  window.history.replaceState(window.history.state, '', url.toString())
}

export function recoverFromChunkLoadError(error: unknown) {
  if (!isChunkLoadError(error)) return false

  const now = Date.now()
  try {
    const lastAttempt = Number(window.sessionStorage.getItem(CHUNK_RELOAD_KEY) ?? 0)
    if (Number.isFinite(lastAttempt) && now - lastAttempt < CHUNK_RELOAD_COOLDOWN_MS) {
      return false
    }
    window.sessionStorage.setItem(CHUNK_RELOAD_KEY, String(now))
  } catch {
    const url = new URL(window.location.href)
    if (url.searchParams.has(CHUNK_RELOAD_PARAM)) return false
  }

  const url = new URL(window.location.href)
  url.searchParams.set(CHUNK_RELOAD_PARAM, String(now))
  window.location.replace(url.toString())
  return true
}

export function clearChunkReloadAttemptSoon() {
  window.setTimeout(() => {
    try {
      window.sessionStorage.removeItem(CHUNK_RELOAD_KEY)
    } catch {
      // storage may be unavailable in hardened WebView/browser contexts.
    }
  }, CHUNK_RELOAD_COOLDOWN_MS)
}
